import React, { useState, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { JobsAPI } from '../../api/client';
import { useMetadata } from '../../hooks/useMetadata';
import InferenceJobForm from '../../components/Forms/Inference/InferenceJobForm';
import SkeletonJobForm from '../../components/Common/SkeletonJobForm';
import {
  defaultFormData,
  buildQuery
} from '../../components/Forms/FormUtils';

const NewInferenceJobPage = () => {
  const [formData, setFormData] = useState(defaultFormData);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { fields, distinct, loading: metadata_loading } = useMetadata();

  // Memoize metadata values to prevent unnecessary re-renders
  const metadataFields = useMemo(() => fields.data || [], [fields.data]);
  const distinctValues = useMemo(() => distinct.data || {}, [distinct.data]);

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const query = buildQuery(formData);
      const payload = {
        query,
        name: formData.name,
        description: formData.description
      };
      const job = await JobsAPI.create(payload);
      navigate(`/jobs/${job.id}`);
    } catch (e) {
      setError('Failed to create job');
    } finally {
      setLoading(false);
    }
  }, [formData, navigate]);

  if (metadata_loading) return <SkeletonJobForm isNewJob={true} />;

  return (
    <InferenceJobForm
      formData={formData}
      setFormData={setFormData}
      isEditing={true}
      metadataFields={metadataFields}
      distinctValues={distinctValues}
      title="Experiment > New"
      onSubmit={onSubmit}
      submitText="Submit"
      submitLoading={loading}
      error={error}
    />
  );
};

export default NewInferenceJobPage;
